import React, { useState } from 'react'
import { api } from '../../../utils/api'

/**
 * AttachmentThumbnail - Displays email attachment with click to view
 */
function AttachmentThumbnail({ ticketId, attachment }) {
  const [loading, setLoading] = useState(false)
  const [imageData, setImageData] = useState(null)
  const [showModal, setShowModal] = useState(false)

  const isImage = attachment.mimeType?.startsWith('image/')

  async function loadAttachment() {
    if (!attachment.attachmentId) return
    setLoading(true)
    try {
      const response = await api.get(`/api/tickets/${ticketId}/attachment/${attachment.attachmentId}`)
      if (response.data) {
        setImageData(response.data)
        if (isImage) {
          setShowModal(true)
        } else {
          // For non-images, trigger download
          const link = document.createElement('a')
          link.href = response.data
          link.download = attachment.filename
          link.click()
        }
      }
    } catch (error) {
      console.error('Failed to load attachment:', error)
      alert('Failed to load attachment')
    } finally {
      setLoading(false)
    }
  }

  const formatSize = (bytes) => {
    if (bytes < 1024) return `${bytes} B`
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
  }

  return (
    <>
      <div
        onClick={loadAttachment}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '8px 12px',
          background: '#f3f4f6',
          borderRadius: 6,
          cursor: 'pointer',
          fontSize: 12,
          maxWidth: 200,
          overflow: 'hidden'
        }}
        title={attachment.filename}
      >
        <span style={{ fontSize: 16 }}>
          {isImage ? '🖼️' : attachment.mimeType?.includes('pdf') ? '📄' : '📎'}
        </span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: 500 }}>
            {loading ? 'Loading...' : attachment.filename}
          </div>
          <div style={{ color: 'var(--muted)', fontSize: 10 }}>
            {formatSize(attachment.size)}
          </div>
        </div>
      </div>

      {/* Image Modal */}
      {showModal && imageData && (
        <div
          className="modalOverlay"
          onClick={() => setShowModal(false)}
          style={{ zIndex: 1001 }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              maxWidth: '90vw',
              maxHeight: '90vh',
              background: 'white',
              borderRadius: 8,
              overflow: 'hidden',
              position: 'relative'
            }}
          >
            <div style={{
              padding: '8px 16px',
              borderBottom: '1px solid rgba(0,0,0,.1)',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <span style={{ fontWeight: 500, fontSize: 14 }}>{attachment.filename}</span>
              <button className="modal-close" onClick={() => setShowModal(false)}>&times;</button>
            </div>
            <img
              src={imageData}
              alt={attachment.filename}
              style={{ maxWidth: '100%', maxHeight: 'calc(90vh - 50px)', display: 'block' }}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default AttachmentThumbnail
